module.exports = __webpack_public_path__ + "static/media/fooddome.1d6bd9cc.svg";